module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-Italic.66b0fef6.otf";